<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
  .el-divider__text, .el-link {
    font-weight: 500;
    font-size: 12px;
  }
  .el-link.el-link--primary {
    font-size: 11px;
  }
  .el-step__title {
    font-size: 13px;
    line-height: 13px;
  }
  .el-badge__content.is-fixed {
    transform: translateY(-10%) translateX(80%)!important;
  }
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 1080px; margin: 0 auto;" >
    <template>
      <el-tabs v-model="active" type="card">
        <el-tab-pane name="bargain">
          <template #label>
            <span><i class="el-icon-connection"></i> 在线报价</span>
            <!-- <el-badge :value="declareResult.goodsNum" class="item"></el-badge> -->
          </template>
          <el-form ref="bargainform" :inline="true" :model="bargainform" size="mini" label-width="80px">
            <el-form-item label="企业名称">
              <el-input v-model="bargainform.producerName" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="通用名">
              <el-input v-model="bargainform.drugName" placeholder="请输入药品通用名"></el-input>
            </el-form-item>
            <el-form-item label="统编代码">
              <el-input v-model="bargainform.code" placeholder="统编代码或产品编码"></el-input>
            </el-form-item>
            <el-form-item label="议价状态">
              <el-radio-group v-model="bargainform.status" @change="getProductDeclarePage">   <!-- 0：未审核，1审核通过，2审核不通过, 3允许继续在线报价 4已失效-->
                <el-radio name="type" :label="5">全部</el-radio>
                <!-- <el-radio name="type" :label="8">已中选</el-radio>
                <el-radio name="type" :label="7">可报价</el-radio>
                <el-radio name="type" :label="4">已失效</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getProductDeclarePage" size="small" round>查&emsp;询</el-button>&emsp;&emsp;
            </el-form-item>
          </el-form>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（质量评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-table :data="bargainform.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef1">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <el-table-column prop="code" label="统编代码" width="170" align='center'></el-table-column>
            <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="drugDosage" label="剂型" width="90" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="packageSpecific" label="包装规格" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="producerName" label="生产企业" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="discount" label="降幅(%)" :formatter="thousandth" width="75" align='right'></el-table-column>
            <el-table-column prop="winPrice" label="中选价格(元)" :formatter="thousandth" width="105" align='right' :show-overflow-tooltip='false'>
              <template slot-scope="scope">
                <template v-if="scope.row.edit"><!-- 可以录入 -->
                  <el-input size="mini" v-model="scope.row.value" style="width: 80px;" placeholder="中选价格"></el-input>
                  <el-link type="primary" :underline="false" style="font-size: 11px;" @click="checkWinPrice(scope.row)">&nbsp;&nbsp;提交</el-link>
                </template>
                <template v-else>
                  <template v-if="8 === scope.row.status">
                    <p>{{ scope.row.winPrice || '-' }}&emsp;<i class="el-icon-edit" style="font-size: 14px; font-weight: 400; color: #1890ff; cursor: pointer;" title="修改" @click="editWinPrice(scope.row)"></i></p>
                  </template>
                  <template v-else>
                    <p>{{ scope.row.winPrice || '-' }}</p>
                  </template>
                </template>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="offerPrice" label="在线报价价格(元)" :formatter="thousandth" width="115" align='right'></el-table-column> -->
            <el-table-column prop="offerDate" label="报价日期" :formatter="toDateString" width="130" align='center'></el-table-column>
            <el-table-column fixed="right" prop="statusDesc" label="重新议价说明" width="105" align='center'></el-table-column>
            <el-table-column fixed="right" prop="statusName" label="状态" width="70" align='center'></el-table-column>
            <el-table-column fixed="right" label="操作" width="120" align='center'>
              <template slot-scope="scope">
                <template v-if="7 == scope.row.status">
                  <el-button type="text" size="mini" @click="handleBeWin(scope.$index, scope.row)">确认中选</el-button>
                </template>
                <template v-if="4 != scope.row.status">
                  <el-button type="text" size="mini" @click="handleExpiry(scope.$index, scope.row)" style="color: #f56c6c;">失效</el-button>
                </template>
                <el-button type="text" size="mini" @click="handleReoffer(scope.$index, scope.row)" style="color: #1890ff;">重议</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'bargainform')" @current-change="(val) => handlePagination(val, null, 'bargainform')" @prev-click="(val) => handlePagination(val, null, 'bargainform')" @next-click="(val) => handlePagination(val, null, 'bargainform')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="bargainform.pageNo"
            :page-sizes="bargainform.pageSizes" :page-size="bargainform.pageSize" :total="bargainform.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane name="record">
          <template #label>
            <span><i class="el-icon-bank-card"></i> 报价记录</span>
          </template>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（质量评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-table :data="bargainOnlineForm.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef2">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <el-table-column prop="producerName" label="企业名称" width="185" align='center'></el-table-column>
            <el-table-column prop="goodsNum" label="报价品种数" width="100" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="offerDate" label="报价时间" :formatter="toDateString" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="attachsName" label="附件名称" align='center' :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <template v-if="!!scope.row.attachsPath">
                  <a :href="`${baseUrl}/member/readflie.jspx?filePath=`+scope.row.attachsPath" target="_blank" style="color: #1890ff; cursor: pointer; font-weight: 500;">{{scope.row.attachsName}}&ensp;<i class="el-icon-download" style="font-size: 14px;"></i></a>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="uploadDate" label="上传时间" :formatter="toDateString" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="statusName" label="状态" width="100" align='center'></el-table-column>
            <el-table-column fixed="right" label="操作" width="200" align='center'>
              <template slot-scope="scope">
                <el-button :loading="submitButtonLoading" size="mini" @click="goPrinter(scope.row)" icon="el-icon-search">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'bargainOnlineForm')" @current-change="(val) => handlePagination(val, null, 'bargainOnlineForm')" @prev-click="(val) => handlePagination(val, null, 'bargainOnlineForm')" @next-click="(val) => handlePagination(val, null, 'bargainOnlineForm')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="bargainOnlineForm.pageNo"
            :page-sizes="bargainOnlineForm.pageSizes" :page-size="bargainOnlineForm.pageSize" :total="bargainOnlineForm.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane name="excel">
          <template #label>
            <span><i class="el-icon-present"></i> 上传下载记录</span>
          </template>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（质量评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-form ref="uploadDownloadForm" :inline="true" :model="uploadDownloadForm" size="mini" label-width="80px">
            <el-form-item label="操作类别">
              <el-radio-group v-model="uploadDownloadForm.category" @change="getUploadDownloadPage">   <!-- 0：未审核，1审核通过，2审核不通过, 3允许继续在线报价 4已失效-->
                <el-radio name="category" :label="5">中选结果上传</el-radio>
                <el-radio name="category" :label="6">企业报价下载</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>&emsp;&emsp;&emsp;</el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-upload2" plain round @click="uploadDownloadForm.visible = true">上传中选</el-button>
                <el-button type="info" icon="el-icon-help" plain></el-button>
                <el-button type="primary" icon="el-icon-download" plain round @click="downloadOfferOnline">下载报价</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <el-table :data="uploadDownloadForm.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef3">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <el-table-column prop="categoryName" label="类别" width="120" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="title" label="处理结果" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="content" label="附件名称" align='center' :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <template v-if="!!scope.row.url">
                  <a :href="`${baseUrl}/member/readflie.jspx?filePath=`+scope.row.url" target="_blank" style="color: #1890ff; cursor: pointer; font-weight: 500;">{{scope.row.content}}&ensp;<i class="el-icon-download" style="font-size: 14px;"></i></a>
                </template>
                <template v-else>
                  {{scope.row.content}}
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作人" width="80" align='center'></el-table-column>
            <el-table-column prop="operatorDate" label="操作时间" :formatter="toDateString" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column fixed="right" label="操作" width="80" align='center'>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'uploadDownloadForm')" @current-change="(val) => handlePagination(val, null, 'uploadDownloadForm')" @prev-click="(val) => handlePagination(val, null, 'uploadDownloadForm')" @next-click="(val) => handlePagination(val, null, 'uploadDownloadForm')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="uploadDownloadForm.pageNo"
            :page-sizes="uploadDownloadForm.pageSizes" :page-size="uploadDownloadForm.pageSize" :total="uploadDownloadForm.total">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>

  <el-dialog title="" center :visible.sync="beChosenVisible" width="1036px" top="145px" style="margin: 0 auto">
    <el-form :model="bargainStep1" ref="bargainStep2">
      <!-- <h2 style="text-align: center; margin-top: 10px;">上海医健卫生事务服务中心</h2> -->
      <p>&nbsp;{{`申报企业：${bargainStep1.producerName}`}}<span style="float: right; font-size: 13px;">{{`报价时间：${bargainStep1.printerDate}`}}</span></p>
      <el-table :data="bargainStep1.data" border style="width: 100%; padding-bottom: 1px; margin-top: 5px;" size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys">
        <el-table-column type="index" label="序号" width="55" align='center'></el-table-column>
        <el-table-column prop="code" label="统编代码" width="135" align='center'></el-table-column>
        <el-table-column prop="drugName" label="药品通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="drugDosage" label="剂型" width="80" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="dosageSpecific" label="规格" width="100" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="packageSpecific" label="包装规格" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="producerName" label="生产企业" width="164" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="drugPackUnit" label="计价单位" width="70" align='center'></el-table-column>
        <el-table-column prop="offer" label="报价价格(元)" width="100" align='right' :formatter="thousandth"></el-table-column>
      </el-table>
    </el-form>
  </el-dialog>

  <el-dialog title="中选目录及价格导入" :visible.sync="uploadDownloadForm.visible" width="600px" style="margin-top: 15px;">
    <el-form :model="uploadDownloadForm" label-width="100px" :inline="true">
      <el-row type="flex">
        <el-form-item label="报价文件上传" prop="attachsName">
          <el-upload
            ref="uploadDownloadForm"
            class="upload-left"
            :action="uploadFileUrl"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleRemoveOfferFile"
            :with-credentials="true"
            :multiple="false"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeOfferFileUpload"
            :on-success="handleSuccessOfferFile"
            :on-error="handleError"
            :file-list="fileListOfferFile">
            <el-button size="small" :loading="submitButtonLoading" type="primary">点我选择文件（限xlsx格式）</el-button>
          </el-upload>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button icon="el-icon-switch-button" size="small" @click="uploadDownloadForm.visible = false" :loading="submitButtonLoading">&emsp;取&emsp;消&emsp;</el-button>
      <el-button type="primary" icon="el-icon-upload" size="small" :loading="submitButtonLoading" @click="submitUpload">开始上传</el-button>
    </span>
  </el-dialog>
  <FooterView></FooterView>
</div>

</template>
<script>
  import print from 'print-js'
  export default {
    name: 'MgrDeclare',
    data(){
      let bargainRules1 = (rule, value, callback) => {
        if(!value || isNaN(value) || 0 > Number(value)){
          callback(new Error(rule.message));
        }
        callback()
      };
      return {
        active: 'bargain',
        height: 0,
        operate: false,
        operator: 0,
        changed: '',
        baseUrl: process.env.VUE_APP_BASE_URL,
        blackInputVisible: true,
        submitButtonLoading: false,
        dialogPasswordVisible: false,
        btnActive: [true, false, false, true, false, false, false, false],
        productOfferList: [],
        bargainActive: 0,
        activeName: '',
        tabPosition: 'left',
        declareResult: null,
        uploadFileUrl: '',
        offerUploadUrl: '',
        fileListOfferFile: [],
        offerAttachs: [],
        queryform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'page', status: 3
        },
        bargainform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getProductDeclarePage', status: 5, producerName: '', drugName: '', code: ''
        },
        bargainOnlineForm: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getBargainOnlinePage', stype: 'OFFERONLINE'
        },
        uploadDownloadForm: {
          pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getUploadDownloadPage', data: [],
          id: '', attachsName: '', attachsPath: '', visible: false, category: 5, credential: ''
        },
        beWinData: [],
        dialogFormVisible: false,
        dialogVisible: false,
        beChosenVisible: false,
        bargainStep1: {
          data: [], count: 0, printerDate: '', producerName: '', captcha: '', attachsName: '', attachsPath: '', id: '', msg: '', onlyPrinter: false
        },
      };
    },
    mounted(){
      // sessionStorage['/mgrdeclare'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight -350}
    },
    created() {
      this.initView();
      //this.captchaUrl = this.getCaptchaUrl();
      this.uploadFileUrl = process.env.VUE_APP_API_URL + 'product/declare/upload.jspx';
      this.offerUploadUrl = process.env.VUE_APP_API_URL + 'member/o_upload_offer.jspx';
    },
    methods: {
      printer(){
        this.$print(this.$refs['bargainStep2'])
      },
      selectable(d){
        return !d.checked;
      },
      thousandth(row, column, cellValue, index){
        if(cellValue && !isNaN(cellValue)){
          let str = new String(cellValue).split('.');
          let re = /\d{1,3}(?=(\d{3})+$)/g;
          let n1 = str[0].replace(re, "$&,");
          return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
        };
      },
      toDateString: function(row, column, cellValue, index){
        if(cellValue && !isNaN(cellValue)){
          let date = new Date(cellValue || new Date())
          ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
          ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
          let format = 'yyyy-MM-dd HH:mm';
          return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
        }
      },
      initView(){
        setTimeout(() => {
          const self = this
          self.submitButtonLoading = true;
          let { status, pageNo, pageSize } = self.bargainform
          self.productDeclarePage({ status, pageNo, pageSize
          }).then(res => {
            self.handleProductDeclarePage(res.data)
            let { stype, pageNo, pageSize } = { ...self.bargainOnlineForm }
            return self.bargainOnlinePage({ stype, pageNo, pageSize })
          }).then(res => {
            self.handleBargainOnlinePage(res.data)
            let { category, pageNo, pageSize } = { ...self.uploadDownloadForm }
            return self.uploadDownloadPage({ category, pageNo, pageSize })
          }).then(res => {
            self.handleUploadDownloadPage(res.data)
          })
        })
      },
      previous() {
        if (this.bargainActive-- < 0) this.bargainActive = 0;
      },
      next(formName) {
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitButtonLoading =  false;
            if (this.bargainActive++ > 4) this.bargainActive = 0;
          } else {
            this.submitButtonLoading =  false;
            return false;
          }
        });
      },
      goPrinter(d){
        this.bargainStep1.data = []
        this.productDeclarePage({ declareResultId: d.id, pageNo: 1, pageSize: 100 }).then(res => {
          JSON.parse(res.data.data).forEach((w, index, arr) => {
            w.offer = w.winPrice
            this.bargainStep1.data.push(w)
          })
          this.bargainStep1.printerDate = this.toDateString(null, null, d.offerDate)
          this.bargainStep1.producerName = d.producerName
          this.beChosenVisible = true;
        })
      },
      getProductDeclarePage: function(){
        this.submitButtonLoading = true;
        let{ status, producerName, drugName, code, pageNo, pageSize } = this.bargainform
        this.productDeclarePage({ status, producerName, drugName, code, pageNo, pageSize }).then(res => {
          this.handleProductDeclarePage(res.data)
        })
      },
      handleProductDeclarePage: function(res){
        this.bargainform.data = [];
        JSON.parse(res.data).forEach((d, index, arr) => {
          d.canSubmit = true
          d.edit = false
          d.id = d.declareId
          if(4 === d.status){
            d.statusName = '已失效'
            d.offerPrice = ''
          }else{
            d.statusName = 8 === d.status ? '已中选' : '可报价'
            d.offerPrice = 8 === d.status ? '' : d.winPrice
            d.winPrice = 8 === d.status ? d.winPrice : ''
          }
          d.value = d.winPrice
          if(d.confirmOn){
            d.offerDate = d.confirmOn.time
          }
          this.bargainform.data.push(d);
        });
        this.bargainform.total = res.count;
      },
      productDeclarePage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productDeclarePage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      getUploadDownloadPage: function(){
        let { category, pageNo, pageSize } = { ...this.uploadDownloadForm }
        this.uploadDownloadPage({ category, pageNo, pageSize }).then(res => {
          this.handleUploadDownloadPage(res.data)
        })
      },
      getBargainOnlinePage: function(){
        let { stype, pageNo, pageSize } = { ...this.bargainOnlineForm }
        this.bargainOnlinePage({ stype, pageNo, pageSize }).then(res => {
          this.handleBargainOnlinePage(res.data)
        })
      },
      bargainOnlinePage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.listDeclareResult(param).then(res => {
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleBargainOnlinePage: function(res){
        this.bargainOnlineForm.data = []
        JSON.parse(res.data).forEach((w, index) => {
          const d = { id: w.id, producerName: w.companyName, goodsNum: w.goodsNum, offerDate: w.createOn.time, attachsName: w.attachsName }
          if(w.uploadOn && w.uploadOn.time >= w.createOn.time){
            d.uploadDate = w.uploadOn.time
          }
          d.statusName = '未上传'
          if(w.attachsPath){
            d.statusName = '已上传'
          }
          this.bargainOnlineForm.data.push(d)
        })
        this.bargainOnlineForm.total = res.count
      },
      uploadDownloadPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.listUploadDownload(param).then(res => {
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleUploadDownloadPage: function(res){
        const arr = [null, null, null, null, null, '中选结果上传', '企业报价下载']
        const self = this
        self.uploadDownloadForm.data = []
        JSON.parse(res.data).forEach((w, index) => {
          if(w.time){
            w.operatorDate = w.time.time
          }
          w.categoryName = arr[w.category]
          self.uploadDownloadForm.data.push(w)
        })
        self.uploadDownloadForm.total = res.count
      },
      getRowKeys(row) {
        if(row.config){
          return row.config.id
        }
        return row.id
      },
      handleClick(tab, event){
        if(this[event]){
          this[event].call(this, tab);
        }
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      checkWinPrice(data) {
        let value = String(data.value);
        if(!value){
          data.tooltipMsg = '请输入中选价格!';
        }else if((isNaN(value) || 0 >= Number(value))){
          data.tooltipMsg = '议价价格应为大于0的数字！';
        }
        data.tooltip = !!data.tooltipMsg
        if(data.tooltip){
          this.$message({ message: data.tooltipMsg, offset: 390, type: 'error' });
          return;
        }
        if(1 < value.split('.').length){
          data.value = value.replace(/([0-9]+\.[0-9]{2})[0-9]*/, '$1')
        }
        if(Number(value) !== Number(data.winPrice)){
          this.confirmWinPrice(data);
        }else{
          data.edit = false;
        }
      },
      confirmWinPrice(data){
        this.$confirm('确认修改中选价格?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let objson = {};
          Object.assign(objson, { id: data.id, price: data.value });
          this.submitWinPrice(objson, '中选价格修改成功！')
        }).catch(() => {
        });
      },
      handleBeWin(idx, data){
        this.$confirm('确认标记中选?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let objson = {};
          Object.assign(objson, { id: data.id, status: 8, price: data.value });
          this.submitWinPrice(objson, '中选标记保存成功！')
        }).catch(() => {
        });
      },
      handleExpiry(idx, data){
        this.$confirm('确认标记失效?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let objson = {};
          Object.assign(objson, { id: data.id, status: 4, price: data.value });
          this.submitWinPrice(objson, '失效标记保存成功！')
        }).catch(() => {
        });
      },
      editWinPrice(data) {
        data.edit = true;
        data.value = data.winPrice || ''
      },
      handleReoffer(idx, data){
        this.$prompt('', '重新议价标记', {
          inputPlaceholder: '请输入重新议价说明',
          confirmButtonText: '提交',
          cancelButtonText: '取消',
          //inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          //inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          let objson = {};
          Object.assign(objson, { id: data.id, status: 7, statusDesc: value });
          this.submitReoffer(objson, '重新议价标记成功！')
        }).catch(() => {});
      },
      cancelCredential(data) {
        data.visible = false;
      },
      submitWinPrice(data, msg) {
        this.submitButtonLoading = true;
        this.$api.memberApi.submitWinPrice(data).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.$message({ message: msg, offset: 200, type: 'success' });
              this.getProductDeclarePage();
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      submitReoffer(data, msg) {
        this.submitButtonLoading = true;
        this.$api.memberApi.submitReoffer(data).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.$message({ message: msg, offset: 200, type: 'success' });
              this.getProductDeclarePage();
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      submitUpload(file){
        if(0 === this.$refs.uploadDownloadForm.uploadFiles.length){
          this.$message({ message: `请选择要上传的Excel文件!`, offset: 200, type: 'warning' });
          return;
        }
        this.$refs.uploadDownloadForm.submit()
      },
      downloadOfferOnline(){
        this.$api.memberApi.downloadOfferOnline({declareId: ''}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              //this.$message({ message: msg, offset: 200, type: 'success' });
              this.getUploadDownloadPage();
              const fileUrl = `${this.baseUrl}/member/readflie.jspx?filePath=${response.data.data}`
              window.open(fileUrl, '_blank')
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      beforeRemove(file, fileList) {
        if(file.status !== 'ready')
          return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleRemoveOfferFile(file, fileList) {
        this.uploadDownloadForm.attachsName = '';
        this.uploadDownloadForm.attachsPath = '';
        this.fileListOfferFile = fileList.slice(0,0);
      },
      handleSuccessOfferFile(response, file, fileList) {
        this.submitButtonLoading = false
        if (response.code === 200) {
          this.fileListOfferFile = [];
          this.uploadDownloadForm.visible = false;
          this.$message({ message: response.data, offset: 200, type: 'success' });
          this.getUploadDownloadPage();
        } else {
          this.$message.error(response.msg);
          this.fileListOfferFile = fileList.slice(0,0);
        }
      },
      handleError(response, file, fileList) {
        this.$message.error(`上传失败，请稍后再试`);
      },
      handlePreview(file) {
        console.log("handlePreview",file);
        let fileUrl = process.env.VUE_APP_BASE_URL + '/member/readflie.jspx?filePath=' + file.response.data;
        //let fileUrl = process.env.VUE_APP_BASE_URL + file.response.data;
        if (!fileUrl.endsWith('.pdf')) {
          this.dialogImageUrl = fileUrl;
          this.dialogImageVisible = true;
        } else {
          this.dialogPdfUrl = fileUrl;
          // this.dialogPdfUrl = pdf.createLoadingTask(fileUrl);
          // this.dialogPdfVisible = true;
          window.open(fileUrl);
        }
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 1 个文件`);
      },
      beforeFileUpload(file) {
        const supportFileType = ["pdf"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message.error('只能上传['+supportFileType+']格式的文件!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      beforeOfferFileUpload(file) {
        const supportFileType = ["xls", "xlsx"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 10;

        if (!isSupport) {
          this.$message({ message: '上传的报价文件格式错误（文件格式应为：' + supportFileType + '）', offset: 200, type: 'error' });
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 10MB!');
        }
        this.submitButtonLoading = isSupport && isLt100M
        return isSupport && isLt100M;
      },
      goLogin(msg) {
        if(msg){
          this.$message({ message: msg, offset: 200, type: 'error' });
        }
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 1500)
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 15px;
  }
  .el-radio__label{
    padding-left: 5px;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 150px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }
  /* .expiry ::placeholder {
    color: #F56C6C !important;
  } */
  .el-form-item__label {
    white-space: pre-line;
  }
  .el-table .cell {
    white-space: pre-line;
  }
  .el-form-item__error{
    font-weight: 500;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Member/MgrDeclare.vue